var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49228 4.06118C2.75588 3.62388 4.20913 2.0364 5.24473 2.08431C5.55456 2.11085 5.82843 2.29741 6.05096 2.51478H6.05182C6.56191 3.01456 8.02543 4.90071 8.1076 5.2978C8.31044 6.27168 7.14903 6.83307 7.50422 7.81466C8.40973 10.0303 9.96998 11.5904 12.1867 12.4949C13.1675 12.8509 13.7289 11.6905 14.7029 11.8925C15.1 11.9755 16.9872 13.438 17.4861 13.9489C17.7027 14.1706 17.891 14.4453 17.9167 14.7551C17.9552 15.8462 16.2692 17.319 15.9405 17.5073C15.1651 18.0627 14.1534 18.0524 12.9202 17.4791C9.47873 16.0473 3.97891 10.6516 2.52052 7.0804C1.96249 5.85406 1.92483 4.83567 2.49228 4.06118Z",
    stroke: "#40C1AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.1387 2.29175C15.2237 2.63425 17.6595 5.06758 18.0062 8.15175",
    stroke: "#40C1AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.1387 5.24414C13.6137 5.53164 14.7662 6.68414 15.0537 8.15914",
    stroke: "#40C1AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.32103579851ced649b4ed621453b2ec6.svg";
export { ForwardRef as ReactComponent };